import React from "react";
import LearnMore from "../../../../components/learnMore/learnMore";

const RevenueLearnMore = () => {
  return <LearnMore title="Total Revenue" content={learnMoreContent()} />;
};

const learnMoreContent = () => (
  <>
    <p>
      The My Dashboard Total Revenue module will show you what revenue your business is bringing in
      as well as what to expect at months end.
    </p>
    <p>
      <b>Month to Date:</b> Based on the date elected at the top of the My Dashboard module, this
      will show from the start of the month until the most recent data update, usually yesterday.
      The small percentage will show a direct comparison to the same dates the previous month. Green
      is a positive change and red is a negative.
    </p>
    <p>
      <b>Month to Date Last Year:</b> Based on the date elected at the top of the My Dashboard
      module, this will show a direct comparison to the same time last year. If you do not have data
      for last year, this will show as $0.
    </p>
    <p>
      <b>Forecast:</b> Our forecasted revenue calculation will give you an idea of where your months
      revenue will end up. Every day we will look at the last 28 days of revenue and remove the EFT
      revenue. Then we take what is left over and divide by 28 to get the daily average. We will use
      this amount and multiply by the number of days left in the month give the Daily Sales Estimate
      value. We will multiply that by the number of days left in the month then add that to both the
      MTD revenue and scheduled remaining revenue to give you a forecast.
      <br />
      The small percentage will show a direct comparison of the forecasted amount to the actual
      revenue from the previous month. Green is a positive change and red is a negative.
    </p>
    <p>
      <u>
        <i>
          New Daily Sales Estimates = ((Revenue (last 28days) - EFT/Scheduled revenue (last
          28days))/28) * Days left in the month
          <br />
          Forecasted Revenue = MTD Revenue + Remaining Revenue + Daily Sales Estimate
        </i>
      </u>
    </p>
    <p>
      <b>Year to Date:</b> Based on the date elected at the top of the My Dashboard module, this
      will show from the start of the year until the most recent data update, usually yesterday. The
      small percentage will show a direct comparison to the same dates the previous year. Green is a
      positive change and red is a negative.
    </p>
    <p>
      <b>Revenue Categories:</b> This area will breakdown your revenue by categories. The categories
      are based on brand level mapping. For each category, you will be able to see the amount,
      percentage of total revenue and compared to last month. The default is the top three by revenue amount
      but you can customize which you want to see. To do this simply click the small negative green
      to the upper right of each donut graph then select from the list of available.
    </p>
    <p>
      <b>Year over Year:</b> This visual line graph gives you a comparison to last year. The default view is a rolling 12-months. If you change the toggle to the OFF position, we will show year to date with the first month starting in January.
    </p>
  </>
);

export default RevenueLearnMore;
